import { DeviceControlExclusionRuleItem } from '@nirvana/shared/dtos/types/policies/common';
import { ColumnKeys } from '../grid-config';
import { compareStrings } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import {
  getLabelByExclusionRuleType,
  getLabelByPermissionType,
} from '../../../../../utils/uiSettings/deviceControl/device-control.values';

export function sortByColumn(
  item1: DeviceControlExclusionRuleItem,
  item2: DeviceControlExclusionRuleItem,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.DESCRIPTION:
      return compareStrings(item1.ruleName, item2.ruleName, direction);
    case ColumnKeys.EXCEPTION:
      return compareStrings(item1.exception, item2.exception, direction);
    case ColumnKeys.PERMISSION:
      return compareStrings(
        getLabelByPermissionType(item1.permission),
        getLabelByPermissionType(item2.permission),
        direction
      );
    case ColumnKeys.RULE_TYPE:
      return compareStrings(
        getLabelByExclusionRuleType(item1.ruleType),
        getLabelByExclusionRuleType(item2.ruleType),
        direction
      );
  }

  return 0;
}
